/**
 * Nombre de la patologia en el idioma de la interfaz.
 *
 * La tabla `pathologies` de la BD solo guarda el nombre en ingles, asi que el
 * texto visible sale de i18n por id (claves `pathologies.1..5`). El nombre que
 * llega del API queda de respaldo, para que un id nuevo aun sin traducir se
 * siga viendo en vez de salir en blanco.
 *
 * Usarlo tambien al filtrar por texto: si se traduce lo que se muestra pero no
 * lo que se busca, buscar por patologia deja de encontrar nada en cuanto la
 * interfaz no esta en ingles.
 */
export const pathologyName = (t, id, fallback = "") =>
  (id ? t(`pathologies.${id}`, { defaultValue: fallback }) : fallback) || "";
